// @flow
import React, { useState, useEffect } from 'react';
import usePreviousPropsAndState from 'hooks/usePreviousPropsAndState';

import {
  LIVE,
  TO_COME,
  OVER,
  DEFAULT_OPTIONS
} from 'components/competitionsInternationales/competitionsInternationalesMatchsResults';
import SingleMatchCard from 'components/competitionsInternationales/SingleMatchCard';
import { WORLD_CUP_DESCRIPTIONS } from 'constants/matchsResultsConstant';

type Props = {
  allMatchs: any[],
  equipeNom: string,
  filter: DEFAULT_OPTIONS
};

function CompetitionsInternationalesMatchsResultsWorldCup({ allMatchs, equipeNom, filter }: Props) {
  const prevAllMatchs = usePreviousPropsAndState(allMatchs);
  const prevFilter = usePreviousPropsAndState(filter);
  const [liveMatch, setLiveMatch] = useState([]);
  const [orderedMatchs, setOrderedMatchs] = useState([]);

  useEffect(() => {
    if (JSON.stringify(prevAllMatchs) !== JSON.stringify(allMatchs) || prevFilter !== filter) {
      // si il y a les filtres => on commence par filtrer
      const newFilter = Array.from(filter);

      let newAllMatchs = allMatchs.filter(match => {
        if (match.rencontre_live === true && match.rencontre_terminee === false) {
          if (newFilter.includes(LIVE)) {
            return match;
          }
        }

        if (match.rencontre_live === false && match.rencontre_terminee === false) {
          if (newFilter.includes(TO_COME)) {
            return match;
          }
        }

        if (match.rencontre_terminee === true) {
          if (newFilter.includes(OVER)) {
            return match;
          }
        }
      });

      // le match live est systématiquement le 1er match affiché et il ne semble pas avoir de titre d'après la maquette
      // pour que le match soit live il faut qu'il ne soit pas terminée / pas de tri à appliquer car devrait être seule
      const liveMatch = newAllMatchs.filter(
        match => match.rencontre_live === true && match.rencontre_terminee === false
      );
      setLiveMatch(liveMatch);

      // ensuite on affiche les matchs par description_match puis par à venir / terminé
      // on récupère la liste des matchs sans le live
      const allMatchsButLive = newAllMatchs.filter(
        match => !(match.rencontre_live === true && match.rencontre_terminee === false)
      );

      if (allMatchsButLive.length > 0) {
        // on va récupérer trier les matchs par description_match
        const newAllMatchsButLive = allMatchsButLive
          .filter(match => {
            const descriptionMatchValue = match.description_match;
            const descriptionMatchExists = WORLD_CUP_DESCRIPTIONS.find(desc => desc.value === descriptionMatchValue);

            if (!!descriptionMatchExists) {
              return match;
            }
          })
          .sort((a, b) =>
            a.description_match < b.description_match ? -1 : a.description_match > b.description_match ? 1 : 0
          );

        const orderedMatchs = newAllMatchsButLive.reduce((acc, match) => {
          const descriptionMatchValue = match.description_match;

          if (!acc[descriptionMatchValue] || !acc[descriptionMatchValue].length) {
            acc[descriptionMatchValue] = [];
          }

          acc[descriptionMatchValue].push(match);

          return acc;
        }, []);

        setOrderedMatchs(orderedMatchs);
      } else {
        setOrderedMatchs([]);
      }
    }
  }, [allMatchs, filter]);

  const equipeName = equipeNom ?? '';

  return (
    <>
      {// le match live est systématiquement le 1er match affiché et il ne semble pas avoir de titre d'après la maquette
      filter.has(LIVE) &&
        liveMatch.map(match => <SingleMatchCard key={match.id} rencontre={match} equipeNom={equipeName} />)}

      {orderedMatchs &&
        !!orderedMatchs.length &&
        orderedMatchs.map((matchList, key) => {
          const descriptionMatchData = WORLD_CUP_DESCRIPTIONS.find(desc => desc.value === key);
          const descriptionMatchTitle = descriptionMatchData.label;
          const titleColor = 'blue';
          matchList.sort((a, b) =>
            new Date(a.date_rencontre) < new Date(b.date_rencontre)
              ? 1
              : new Date(a.date_rencontre) > new Date(b.date_rencontre)
              ? -1
              : 0
          );

          return (
            <>
              <h3 className={titleColor ? `single-match-card__title is-${titleColor}` : ''}>{descriptionMatchTitle}</h3>
              <hr className="single-match-card__hr mb-6" />

              {matchList.map(match => (
                <SingleMatchCard key={match.id} rencontre={match} equipeNom={'France'} />
              ))}
            </>
          );
        })}

      {(!liveMatch || !liveMatch.length) && (!orderedMatchs || !orderedMatchs.length) && (
        <p className="empty-state">Aucun match ne correspond à vos filtres</p>
      )}
    </>
  );
}

export default CompetitionsInternationalesMatchsResultsWorldCup;
